module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('div', {
    staticClass: "box "
  }, [_c('div', {
    staticClass: "active-search",
    on: {
      "click": function($event) {
        _vm.showSearch = true
      }
    }
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/icon-index-search.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "active-search-name"
  }, [_vm._v("搜索项目/单位/队伍")])])]), _vm._v(" "), _c('div', {
    staticClass: "active-item"
  }, [_c('p', {
    staticClass: "active-item-name"
  }, [_vm._v(_vm._s(_vm.row.name))]), _vm._v(" "), _c('div', {
    staticClass: "active-item-info"
  }, [_c('img', {
    attrs: {
      "src": _vm.row.pic_url,
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "info-top-left"
  }, [_vm._v("正在进行")]), _vm._v(" "), _c('div', {
    staticClass: "info-bottom"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('span', [_vm._v(_vm._s(_vm.row.member_count) + "人参加")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('span', [_vm._v(_vm._s(_vm.row.saidate_str))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.row.province) + " " + _vm._s(_vm.row.city) + " ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "top-tabs"
  }, [_c('van-tabs', {
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('van-tab', {
    attrs: {
      "title": "全部"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "排行"
    }
  })], 1)], 1), _vm._v(" "), _c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('div', {
    staticClass: "vote-list"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "li",
      on: {
        "click": function($event) {
          return _vm.goDetail(item)
        }
      }
    }, [_c('div', {
      staticClass: "cover"
    }, [_c('img', {
      attrs: {
        "src": item.pic_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.vote_count) + "票")])]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v("\n\t\t\t\t" + _vm._s(item.mingcheng) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "subject"
    }, [_vm._v(_vm._s(item.subject_name))]), _vm._v(" "), _c('div', {
      staticClass: "member"
    }, [_vm._l((item.yundongyuan), function(member, index) {
      return _c('span', {
        key: index
      }, [_vm._v(_vm._s(member.name) + " ")])
    }), _vm._v(" ")], 2), _vm._v(" "), _c('div', {
      staticClass: "member"
    }, [_vm._l((item.jiaolian), function(member, index) {
      return _c('span', {
        key: index
      }, [_vm._v(_vm._s(member.name) + " ")])
    }), _vm._v(" ")], 2), _vm._v(" "), _c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.vote(item)
        }
      }
    }, [_vm._v("投TA一票")])])
  }), 0)])], 1), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "搜索",
      "show-cancel-button": ""
    },
    on: {
      "confirm": _vm.onSearchConfrim,
      "cancel": _vm.onSearchCancel
    },
    model: {
      value: (_vm.showSearch),
      callback: function($$v) {
        _vm.showSearch = $$v
      },
      expression: "showSearch"
    }
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "size": "large",
      "clearable": "",
      "placeholder": "搜索项目/单位/队伍"
    },
    model: {
      value: (_vm.params.keywords),
      callback: function($$v) {
        _vm.$set(_vm.params, "keywords", $$v)
      },
      expression: "params.keywords"
    }
  })], 1)], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16565f0c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/VoteList.vue
// module id = 1365
// module chunks = 0